/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Delete_PermanentInputs */

const cs_settings_venues_delete_permanent = /** @type {(inputs: Settings_Venues_Delete_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazání pobočky je trvalé. Poslední pobočku smazat nelze.`)
};

const en_settings_venues_delete_permanent = /** @type {(inputs: Settings_Venues_Delete_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting a venue is permanent. The last venue cannot be deleted.`)
};

/**
* | output |
* | --- |
* | "Deleting a venue is permanent. The last venue cannot be deleted." |
*
* @param {Settings_Venues_Delete_PermanentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_delete_permanent = /** @type {((inputs?: Settings_Venues_Delete_PermanentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Delete_PermanentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_delete_permanent(inputs)
	return cs_settings_venues_delete_permanent(inputs)
});